webpackJsonp([8],{

/***/ "6GnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VImage_vue__ = __webpack_require__("MsHz");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73811e00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VImage_vue__ = __webpack_require__("hbdA");
function injectStyle (ssrContext) {
  __webpack_require__("jCdm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73811e00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MsHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_native_util_js__ = __webpack_require__("UTZg");
//
//
//
//
//
//
//
//
//
//




var thinRatio = 1 / 6;
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        target: {
            default: '',
            type: String
        },
        spm: {
            default: '',
            type: String
        },
        data: {
            default: {},
            type: [Object, Array]
        },
        findex: {
            default: '',
            type: [String, Number]
        }
    },
    data: function data() {
        return {
            show_info: false,
            isThinImg: false
        };
    },

    methods: {
        getImgNaturalDimensions: function getImgNaturalDimensions(img, callback) {
            var nWidth = 0,
                nHeight = 0,
                image;
            if (!img) {
                callback(nWidth, nHeight);
                return;
            }
            if (img.naturalWidth) {
                // 现代浏览器
                nWidth = img.naturalWidth;
                nHeight = img.naturalHeight;
                callback(nWidth, nHeight);
            } else {
                // IE6/7/8
                img.onload = function () {
                    callback(img.width, img.height);
                };
            }
        },
        clickItemHandler: function clickItemHandler(data) {
            var url = this.$refs.img.getAttribute('href');
            __WEBPACK_IMPORTED_MODULE_1__utils_native_util_js__["a" /* default */].openContent(url, data);
        }
    },
    mounted: function mounted() {
        var _this = this;

        var that = this;
        var img_bg = this.$refs.img_bg;
        this.getImgNaturalDimensions(img_bg, function (width, height) {
            var ratio = void 0;
            if (width > 0 && height > 0) {
                ratio = height / width;
                if (ratio > thinRatio) {
                    that.isThinImg = false;
                } else {
                    that.isThinImg = true;
                }
            }
            that.show_info = true;
        });
        this.$nextTick(function () {
            var dom = document.getElementById(_this.target);
            if (dom != null) {
                var imgList = dom.querySelectorAll('a[data-log-content-ev]');
                _this.$emit('mounted', imgList);
            }
        });
    },

    computed: {
        item: function item() {
            var item = {};
            var subId = window.subData.id;
            var stat_flag = 'm-' + subId + '_subpics_' + this.findex;
            if (this.data[0]) {
                item = this.data[0];
                item.stat_flag = stat_flag;
                if (item.link) {
                    item.link = __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].addQueryArgs(item.link, {
                        _f: stat_flag
                    });
                }
            }
            return item;
        },
        has_data: function has_data() {
            return this.data.length > 0 && this.item.imageUrl;
        },
        img_info: function img_info() {
            return this.isThinImg ? 'thin-info' : 'info';
        }
    }
});

/***/ }),

/***/ "UTZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");


var nativeUtil = {
    openContent: function openContent(url, data) {
        if (!url) {
            return;
        }
        if (/MSOHU/i.test(window.navigator.userAgent) && window.Panther) {
            var urlObj = __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].parseURL(url);
            var spmCode = urlObj.spm || '';
            var scmCode = urlObj.scm || '';
            var regMatch = /\/(a|picture)\/(\d+)(_\d+\?|\?)/.test(url);
            var authorId = data.authorId || data.authId;
            if (RegExp.$1 === 'a') {
                // 匹配文章页
                if (typeof Panther.openNewsContent === 'function') {
                    Panther.openNewsContent(RegExp.$2, spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else if (RegExp.$1 === 'picture') {
                // 匹配图集页
                if (typeof Panther.openImageSet === 'function') {
                    Panther.openImageSet(Number(RegExp.$2), spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else {
                window.location.href = url;
            }
        } else {
            window.location.href = url;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (nativeUtil);

/***/ }),

/***/ "cRqV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.img-wrap {\n  position: relative;\n  margin: 0.266667rem 0.346667rem;\n  overflow: hidden;\n  font-size: 18px;\n}\n.img-wrap .image {\n  position: relative;\n}\n.img-wrap .image[src$=\"preload.png\"] {\n  height: 4.653333rem;\n}\n.img-wrap .thin-info {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 70%;\n  left: 0;\n  bottom: 0;\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(57, 57, 57, 0.85)));\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));\n}\n.img-wrap .thin-info .tt {\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-left: 0.24rem;\n  padding-right: 0.16rem;\n  width: 100%;\n  bottom: 0.32rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #fff;\n  font-weight: bold;\n}\n.img-wrap .info {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 2.133333rem;\n  left: 0;\n  bottom: 0;\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(57, 57, 57, 0.85)));\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));\n}\n.img-wrap .info .tt {\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-left: 0.24rem;\n  padding-right: 0.16rem;\n  bottom: 0.32rem;\n  font-size: 18px;\n  line-height: 1.3em;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  display: box;\n  -webkit-box-orient: vertical;\n  color: #fff;\n  font-weight: bold;\n}", ""]);

// exports


/***/ }),

/***/ "hbdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_data)?_c('div',{staticClass:"img-wrap module-wrap",attrs:{"id":_vm.target,"data-spm":_vm.spm}},[_c('a',{ref:"img",staticClass:"link",attrs:{"href":_vm.item.link ? _vm.item.link : 'javascript:;',"data-log-content-ev":_vm.item.stat_flag},on:{"click":function($event){$event.preventDefault();_vm.clickItemHandler(_vm.item)}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.item.imageUrl),expression:"item.imageUrl"}],ref:"img_bg",staticClass:"image"}),_vm._v(" "),_c('footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_info),expression:"show_info"}],class:_vm.img_info},[_c('h3',{staticClass:"tt"},[_vm._v(_vm._s(_vm.item.title))])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jCdm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cRqV");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0c86d6de", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.796d3e042ea8f6df252a.js